import { IZoneTypeQuery } from "../../../models/wms/zone-type/query";
import {
  IZoneType,
  IZoneTypeDetails,
} from "../../../models/wms/zone-type/response";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import toggleLoading from "../../../utils/helpers/xor";
import paramsReducer from "../../base/base-reducer";
import { QueryAction } from "../../base/base-reducer";
import {
  IInternalState,
  ZoneTypeLoading,
} from "./context";

type Action =
  | {
      type: "LOADING";
      payload: {
        loading: ZoneTypeLoading | ZoneTypeLoading[];
      };
    }
  | {
      type: "SET_LIST";
      payload: { list: IBaseListingResponse<IZoneType> };
    }
  | {
      type: "SET_DETAILS";
      payload: { details?: IZoneTypeDetails };
    }
  | QueryAction<IZoneTypeQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
